// Copied verbatim from the parent blue-haven theme so the local HeroImageBG
// override can render the same decorative wave band without deep-importing
// into a parent-src path (which is a lint error). Not a registered slot —
// no contentSchema — so the schema linter skips this file.
import { useId } from 'react';

function WaveSvg({
  patternId,
  height,
  spacing,
  amp,
  className,
}: {
  patternId: string;
  height: number;
  spacing: number;
  amp: number;
  className: string;
}) {
  return (
    <svg
      className={`block w-full ${className}`}
      width="100%"
      height={height}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <pattern id={patternId} x="0" y="0" width="280" height={height} patternUnits="userSpaceOnUse">
          {Array.from({ length: Math.ceil(height / spacing) + 1 }).map((_, i) => {
            const y = i * spacing;
            return (
              <path
                key={i}
                d={`M0 ${y} q70 ${-amp} 140 0 t140 0`}
                fill="none"
                stroke="var(--vibe-color-primary)"
                strokeWidth={1.5}
              />
            );
          })}
        </pattern>
      </defs>
      <rect width="100%" height={height} fill={`url(#${patternId})`} />
    </svg>
  );
}

export function WaveBand({
  className = '',
  height = 100,
  spacing = 18,
  amp = 30,
  mobileHeight,
  mobileSpacing,
  mobileAmp,
}: {
  className?: string;
  height?: number;
  spacing?: number;
  amp?: number;
  mobileHeight?: number;
  mobileSpacing?: number;
  mobileAmp?: number;
}) {
  const base = `wave-${useId().replace(/:/g, '')}`;
  const mHeight = mobileHeight ?? height / 2;
  const mSpacing = mobileSpacing ?? spacing / 2;
  const mAmp = mobileAmp ?? amp / 2;
  return (
    <div className={`leading-[0] ${className}`} aria-hidden="true">
      <WaveSvg patternId={`${base}-d`} height={height} spacing={spacing} amp={amp} className="hidden lg:block" />
      <WaveSvg
        patternId={`${base}-t`}
        height={height / 2}
        spacing={spacing / 2}
        amp={amp / 2}
        className="hidden md:block lg:hidden"
      />
      <WaveSvg patternId={`${base}-m`} height={mHeight} spacing={mSpacing} amp={mAmp} className="md:hidden" />
    </div>
  );
}
